import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input, InputType, InputState, Label, allowOnlyNumbers } from '@as/cotopaxi';
import { Box, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const INPUT_ID = 'price-amount-input';
export const PriceAmount = ({ error, amount, currency, minAmount, maxAmount, onInputBlur, onAmountChange, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.general, I18N_NAMESPACES.checkout]);
    return (_jsxs(Stack, { direction: "col", gap: "1", children: [_jsx(Label, { htmlFor: INPUT_ID, children: _jsx(TextAlpha, { strong: true, variant: "bodyS", as: "span", children: t('general:gift.card.custom.amount', {
                        currency,
                        min: minAmount,
                        max: maxAmount,
                    }) }) }), _jsx(Box, { paddingInlineEnd: "16", children: _jsx(Input, { required: true, id: INPUT_ID, name: INPUT_ID, type: InputType.NUMBER, value: amount, min: Number(minAmount), max: Number(maxAmount), state: error && InputState.ERROR, onKeyDown: allowOnlyNumbers, onBlur: onInputBlur, onChange: onAmountChange, placeholder: `${currency}${minAmount} - ${currency}${maxAmount}` }) }), error && (_jsx(TextAlpha, { color: "error", variant: "bodyS", as: "span", children: t(error, {
                    currency,
                    min: minAmount,
                    max: maxAmount,
                }) }))] }));
};
